<template>
  <d-modal v-if="showModal" size="lg">
    <d-modal-header :close="false">
      <d-modal-title>Update Product Name and Pricing</d-modal-title>
    </d-modal-header>
    <d-modal-body v-if="diff == null">
      <div class="container">
        <div class="large-12 medium-12 small-12 cell">
          <label
            >File
            <input
              type="file"
              id="file"
              ref="file"
              v-on:change="handleFileUpload()"
            />
          </label>
        </div>
      </div>
      <div v-if="!!error" class="text-danger">{{ error }}</div>
      <div class="d-flex justify-content-end align-items-center pt-3">
        <d-button class="mx-2" theme="light" @click="handleClose"
          >Cancel</d-button
        >
        <async-button
          @click="updateProducts"
          text="Continue"
          loadingText="saving..."
          :loading="loading"
          :enabled="!!this.file"
        />
      </div>
    </d-modal-body>
    <d-modal-body v-else>
      <BulkUpdateDiff :diff="diff" />
      <d-button class="mx-2" theme="light" @click="handleClose">Close</d-button>
    </d-modal-body>
  </d-modal>
</template>

<script>
import BulkUpdateDiff from "@/components/BulkUpdateDiff";

export default {
  data() {
    return {
      file: "",
      error: "",
      loading: false,
      diff: null
    };
  },
  components: {
    BulkUpdateDiff
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showModal() {
      this.resetForm();
    }
  },
  methods: {
    resetForm() {
      this.file = "";
      this.updates = null;
    },
    handleClose(event) {
      this.$emit("close", this.updates !== null);
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    updateProducts() {
      this.loading = true;
      this.error = "";
      let formData = new FormData();
      formData.append("file", this.file);
      this.$store
        .dispatch("products/updateAll", formData)
        .then(data => {
          if (data.status == "error") {
            this.error = data.message;
          } else if (data.status == "ok") {
            this.diff = data.diff;
          }
        })
        .catch(() => {
          this.error = "error uploading file";
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
